<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>All Categories</h2> -->
                    <h2>
                        <li class="breadcrumb-item">
                            <a href="index.html">
                                <i class="fa-solid fa-house"></i>
                            </a>
                        </li>
                        <li class="breadcrumb-item active">All Categories</li>
                    </h2>
                    <nav>
                        <ol class="breadcrumb mb-0">

                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->

<!-- Category Section Start -->
<section class=" svr_padbto">
    <div class="container-fluid-lg loader" *ngIf="isLoading">
        <div class="row ">
            <div class="col-12 d-flex justify-content-center ">
                <div class="spinner-border text-success " role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid-lg">
        <div class="row" *ngIf="!isLoading && DataList?.length; else emptydata">
            <div class="col-12" *ngFor="let Data of DataList">
                <div class="title pointer">
                    <h2 (click)="navigateToShopDetail(Data.id, '0',Data?.category_slug)">{{ Data?.category_name || "" }}</h2>
                </div>
                <div class="shop-box svr_shopboxes" *ngIf="Data?.subcategory?.length > 0; else emptySubcategory">
                    <div class="shop-category-box" *ngFor="let subcategoryData of Data?.subcategory">
                        <a>
                            <div class="shop-category-image pointer" (click)="navigateToShopDetail(Data?.id, subcategoryData?.id,Data?.category_slug)">
                                <!-- <img src="assets/svg/1/vegetable.svg" class="blur-up lazyload" alt=""> -->
                                <img [src]="imageBaseUrl + subcategoryData?.subcategory_image" class="blur-up lazyload" alt="">

                            </div>
                            <div class="category-box-name">
                                <h6>{{ subcategoryData?.subcategory_name }}</h6>
                            </div>
                        </a>
                    </div>


                </div>
                <ng-template #emptySubcategory>
                    <div class="svr_nodata" *ngIf="!isLoading">
                        <h4>No data available!</h4>
                        <p>No subcategories available for "{{ Data?.category_name || 'this category' }}".</p>
                    </div>
                </ng-template>
            </div>

        </div>
        <ng-template #emptydata>
            <div class="row" *ngIf="!isLoading">
                <div class="col-12 d-flex justify-content-center">
                    <div class="svr_nodata">
                        <h4>No data available!</h4>
                        <p>There is no data to show you right now</p>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</section>
<!-- Category Section End -->
